<datex-grid #$gridComponent *ngIf="initialized && !$hasMissingRequiredInParams" [selection]="true" (selectionChange)="$selectionChanged($event)" [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"
[canEdit]="canEdit"
[canAdd]="canAdd" [addNewRowFn]="addRow.bind(this)" [addLineModel]="bottomToolbar.addLine"

>
    <ng-container topToolbar>
      <app-toolbar [toolbar]="topToolbar">
          <ng-template 
            toolbarToolDef="on_delete" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <button mat-button
                    data-cy="button"
                    class="datex-button"
                    [disabled]="tool.control.readOnly || tool.control.disabled"
                    [ngStyle]="tool.control.styles.style"
                    [ngClass]="tool.control.styles.classes"
                    [matTooltip]="tool.control.tooltip"
                    matTooltipClass="datex-control-tooltip"
                    (click)="on_delete_clicked($event)"
                    >
              <div class="button-label">
                <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                  <div class="button-icon">
                    <i data-cy="button-icon" class="datex-default-spinner"></i>
                  </div>
                </ng-container>
                <ng-template #showIcon>
                  <div class="button-icon">
                    <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                  </div>
                </ng-template>
                <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
              </div>
            
            </button>
            </ng-container>
          </ng-template>
      </app-toolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch"
        matTooltipClass="datex-control-tooltip">
    </div>
  </ng-container>


  <ng-container gridColumnDef="substitution_material_id">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.substitution_material_id.displayControl.styles.style"
          [ngClass]="row.cells.substitution_material_id.displayControl.styles.classes"
          [matTooltip]="row.cells.substitution_material_id.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.substitution_material_id.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <Materials-materials_by_project_excl_material_dd_single 
        data-cy="selector"
        [type]="row.cells.substitution_material_id.editControl.type"
        [formControl]="row.formGroup.controls['substitution_material_id_edit']"
        (displayTextChange)="row.cells.substitution_material_id.editControl.displayText=$event"
        [placeholder]="row.cells.substitution_material_id.editControl.placeholder"
        [styles]="row.cells.substitution_material_id.editControl.styles"
        [tooltip]="row.cells.substitution_material_id.editControl.tooltip"
      [project_id]="row.$fields_substitution_material_id_selector_inParams_project_id"
      [excluded_material_id]="row.$fields_substitution_material_id_selector_inParams_excluded_material_id"
    >
    </Materials-materials_by_project_excl_material_dd_single>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="substitution_packaging_id">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.substitution_packaging_id.displayControl.styles.style"
          [ngClass]="row.cells.substitution_packaging_id.displayControl.styles.classes"
          [matTooltip]="row.cells.substitution_packaging_id.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.substitution_packaging_id.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <Materials-material_packagings_dd_single 
        data-cy="selector"
        [type]="row.cells.substitution_packaging_id.editControl.type"
        [formControl]="row.formGroup.controls['substitution_packaging_id_edit']"
        (displayTextChange)="row.cells.substitution_packaging_id.editControl.displayText=$event"
        [placeholder]="row.cells.substitution_packaging_id.editControl.placeholder"
        [styles]="row.cells.substitution_packaging_id.editControl.styles"
        [tooltip]="row.cells.substitution_packaging_id.editControl.tooltip"
      [materialId]="row.$fields_substitution_packaging_id_selector_inParams_materialId"
    >
    </Materials-material_packagings_dd_single>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ratio">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.ratio.displayControl.styles.style"
          [ngClass]="row.cells.ratio.displayControl.styles.classes"
          [matTooltip]="row.cells.ratio.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.ratio.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="numberBox" [formControl]="row.formGroup.controls['ratio_edit']"
            matInput
            numberBox
            [format]="row.cells.ratio.editControl.format"
            autocomplete="off"
            spellcheck="false"
            class="datex-numberbox {{ (row.cells.ratio.editControl.readOnly || row.cells.ratio.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.ratio.editControl.placeholder}}"
            [ngStyle]="row.cells.ratio.editControl.styles.style"
            [ngClass]="row.cells.ratio.editControl.styles.classes"
            [matTooltip]="row.cells.ratio.editControl.tooltip"
            matTooltipClass="datex-control-tooltip">
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="priority">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.priority.displayControl.styles.style"
          [ngClass]="row.cells.priority.displayControl.styles.classes"
          [matTooltip]="row.cells.priority.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.priority.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="numberBox" [formControl]="row.formGroup.controls['priority_edit']"
            matInput
            numberBox
            [format]="row.cells.priority.editControl.format"
            autocomplete="off"
            spellcheck="false"
            class="datex-numberbox {{ (row.cells.priority.editControl.readOnly || row.cells.priority.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.priority.editControl.placeholder}}"
            [ngStyle]="row.cells.priority.editControl.styles.style"
            [ngClass]="row.cells.priority.editControl.styles.classes"
            [matTooltip]="row.cells.priority.editControl.tooltip"
            matTooltipClass="datex-control-tooltip">
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
<div *ngIf="$hasMissingRequiredInParams" class="missing-params">
  <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
</div>
